import axios from '../utils/axios';

export default function fetchTagMailers(adminId, id) {
    return (
        axios.get(`/admin/${adminId}/tag-mailers/${id}`)
    )
}
